import { config } from '../config';

function buildBase() {
  const base = config.apiBase || '/api';
  if (base.startsWith('http')) return base.replace(/\/$/, '');
  // relative path -> join with current origin
  return (location.origin + (base.startsWith('/') ? '' : '/') + base).replace(/\/$/, '');
}
const API_BASE = buildBase();

export async function api(path: string, init: RequestInit = {}) {
  const res = await fetch(API_BASE + path, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(init.headers || {}) },
    ...init,
  });
  
  if (!res.ok) {
    const t = await res.text().catch(() => "");
    throw new Error(t || `HTTP ${res.status}`);
  }
  const ct = res.headers.get("Content-Type") || "";
  return ct.includes("application/json") ? res.json() : res.text();
}

